import React, { useState } from 'react';
import { X, Plus, Trash2, MessageSquare } from 'lucide-react';
import { loadConversations, deleteConversation } from '../lib/chatHistory';

const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString('fr-FR', {
      day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return '';
  }
};

const ChatHistoryPanel = ({ onClose, onOpen, onNew, activeId }) => {
  const [conversations, setConversations] = useState(loadConversations);

  const handleDelete = (e, id) => {
    e.stopPropagation();
    deleteConversation(id);
    setConversations(loadConversations());
  };

  return (
    <div
      data-testid="history-overlay"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9000,
        background: 'rgba(11, 18, 32, 0.45)',
        display: 'flex', justifyContent: 'flex-end',
      }}
    >
      <div
        data-testid="history-panel"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 'min(360px, 92vw)', height: '100%',
          background: 'var(--bg-white)',
          display: 'flex', flexDirection: 'column',
          boxShadow: '-8px 0 32px rgba(0,0,0,0.2)',
        }}
      >
        <div style={{
          padding: '16px 18px', borderBottom: '1px solid var(--border)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <h2 style={{ fontSize: '15px', fontWeight: 700, color: 'var(--text-dark)' }}>
            Historique des conversations
          </h2>
          <button
            onClick={onClose}
            data-testid="history-close-btn"
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: 'var(--text-gray)', padding: '4px', display: 'flex',
            }}
          >
            <X style={{ width: 18, height: 18 }} />
          </button>
        </div>

        <button
          onClick={onNew}
          data-testid="history-new-conversation-btn"
          style={{
            margin: '12px 18px', padding: '11px',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
            background: 'var(--primary)', color: '#fff',
            border: 'none', borderRadius: '10px',
            fontSize: '13px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
          }}
        >
          <Plus style={{ width: 15, height: 15 }} /> Nouvelle conversation
        </button>

        <div style={{ flex: 1, overflowY: 'auto', padding: '0 12px 16px' }}>
          {conversations.length === 0 ? (
            <div
              data-testid="history-empty"
              style={{
                textAlign: 'center', padding: '40px 20px',
                color: 'var(--text-gray)', fontSize: '13px',
              }}
            >
              <MessageSquare style={{ width: 28, height: 28, margin: '0 auto 10px', opacity: 0.4 }} />
              Aucune conversation enregistrée pour le moment.
            </div>
          ) : (
            conversations.map((convo, idx) => (
              <div
                key={convo.id}
                onClick={() => onOpen(convo)}
                data-testid={`history-item-${idx}`}
                style={{
                  padding: '12px', marginBottom: '8px',
                  borderRadius: '10px', cursor: 'pointer',
                  border: `1px solid ${convo.id === activeId ? 'var(--primary)' : 'var(--border)'}`,
                  background: convo.id === activeId ? 'var(--bg-icon)' : 'transparent',
                  display: 'flex', alignItems: 'flex-start', gap: '8px',
                  transition: 'background-color 0.15s, border-color 0.15s',
                }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{
                    fontSize: '13px', fontWeight: 600, color: 'var(--text-dark)',
                    overflow: 'hidden', textOverflow: 'ellipsis',
                    display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                    lineHeight: 1.4,
                  }}>
                    {convo.title}
                  </div>
                  <div style={{ fontSize: '11px', color: 'var(--text-gray)', marginTop: '4px' }}>
                    {formatDate(convo.updatedAt)} · {Math.max(0, (convo.messages?.length || 1) - 1)} message{(convo.messages?.length || 1) - 1 > 1 ? 's' : ''}
                  </div>
                </div>
                <button
                  onClick={(e) => handleDelete(e, convo.id)}
                  data-testid={`history-item-delete-${idx}`}
                  aria-label="Supprimer la conversation"
                  style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    color: 'var(--text-gray)', padding: '4px', display: 'flex', flexShrink: 0,
                  }}
                >
                  <Trash2 style={{ width: 15, height: 15 }} />
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatHistoryPanel;
